// extracted by mini-css-extract-plugin
module.exports = {"sticky":"FilmEquipmentProducts_sticky__2SDyp","root":"FilmEquipmentProducts_root__2CjsC"};